<template>
  <a-layout-content class="p-all">
    <keep-alive>
      <router-view />
    </keep-alive>
  </a-layout-content>
</template>

<script>
export default {
  name: "absenPhoto",
  data() {
    return {};
  }
};
</script>

<style>
</style>
